export default __webpack_public_path__ + "static/media/thumb_2_bs2.2f1665d9.png";